import { render } from "./HistoryView.vue?vue&type=template&id=66e3cbe2&scoped=true&ts=true"
import script from "./HistoryView.vue?vue&type=script&lang=ts"
export * from "./HistoryView.vue?vue&type=script&lang=ts"

import "./HistoryView.vue?vue&type=style&index=0&id=66e3cbe2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e3cbe2"]])

export default __exports__